import * as React from 'react';
import { Survey, LanguageCode, getSurveyStatus } from '../../amorg-common';
import { basicValidation } from '../../amorg-common';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { stxt } from '../../SurveyTxt';
import { TextField } from '../../designSystem/formField/text/TextField';
import { Button } from '../../designSystem/button/Button';
import { startAnswer } from '../../api/surveySubmissionClientApi';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { P } from '../../designSystem/typography/Body';
import { MessageCard } from '../../designSystem/Message';


export type LoadStatus = 'loading' | 'done' | 'error';
type SubmissionResult = 'pending' | 'success' | 'failure';

export type StartAnswerProps = {
    loadStatus: LoadStatus,
    siteId: string,
    survey: Survey,
    email: string,
    selectedLanguage:LanguageCode,
    onEmailChange: (val: string) => void
}
export function StartAnswer(props: StartAnswerProps): JSX.Element {
    const [didSubmit, setDidSubmit] = React.useState(false);
    const [submissionResult, setSubmissionResult] = React.useState<SubmissionResult>('pending');

    async function handleClickSubmit() {
        const result = await startAnswer(props.siteId, props.survey.id, props.email);
        setSubmissionResult(result.isSuccess ? 'success' : 'failure');
        setDidSubmit(true);
    }

    const txt = stxt(props.selectedLanguage);

    return (
        <>
            {props.loadStatus === 'loading' &&
                <LoadingPageOverlay loading={true} />
            }

            {props.loadStatus === 'error' &&
                <p>{txt.startAnswer_error}</p>
            }

            {props.loadStatus === 'done' && !getSurveyStatus(props.survey).canSubmitAnswer &&
                <p>{txt.startAnswer_surveyClosed}</p>
            }

            {props.loadStatus === 'done' && getSurveyStatus(props.survey).canSubmitAnswer &&
                <Flex flexDirection="column" gap={24}>
                    <>
                    <P>
                        {txt.startAnswer_intro1}<br />
                        <br />
                        {txt.startAnswer_intro2}<br />
                        <br />
                        {txt.startAnswer_intro3}<br />
                    </P>

                    {submissionResult === 'failure' &&
                        <MessageCard variant="error">
                            {txt.startAnswer_submissionError}
                        </MessageCard>
                    }

                    {submissionResult === 'success' &&
                        <MessageCard variant="success">
                            {txt.startAnswer_submissionSuccess}
                        </MessageCard>
                    }
                    
                    {submissionResult !== 'success' &&
                        <>
                            <div style={{height:'100px'}}>
                                <TextField
                                    label="Email"
                                    value={props.email}
                                    onChange={props.onEmailChange}
                                    validator={value => !didSubmit || basicValidation.isValidEmail(value)
                                        ? {valid:true}
                                        : {valid:false, errorMessage:txt.startAnswer_invalidEmailError}
                                    } />    
                            </div>
                            
                            <Button
                                variant="filled"
                                onClick={handleClickSubmit}
                                text={txt.startAnswer_buttonRequestLink} 
                                heightOverride='42px' />
                                </>
                    }
                    </>
                    
                </Flex>
            }
        </>
    );
}


